<template lang="pug">
vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="!$v.form.$invalid" :vm-active="isModalVisible" :vm-title='getTitle')
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true, disabled: $v.form.$invalid },]")
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-input(autofocus :placeholder='$t("contacts.name_placeholder")' :danger="$v.form.name.$invalid && $v.form.name.$model" :danger-text="$t('validation.required', { attribute: $t('contacts.name') })" v-model="form.name" :label='$t("contacts.name")')
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-input(:placeholder='$t("contacts.position_placeholder")' :danger="$v.form.position.$invalid && $v.form.position.$model" :danger-text="$t('validation.required', { attribute: $t('contacts.position') })" v-model="form.position" :label='$t("contacts.position")')
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-input(type="number" :placeholder='$t("contacts.phone_placeholder")' :danger="$v.form.phone.$invalid && $v.form.phone.$model" :danger-text="$t('validation.required', { attribute: $t('contacts.phone') })" v-model="form.phone" :label='$t("contacts.phone")')
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-input(:placeholder='$t("contacts.email_placeholder")' :danger="$v.form.email.$invalid && $v.form.email.$model" :danger-text="$t('validation.email', { attribute: $t('contacts.email') })" v-model="form.email" :label='$t("contacts.email")' required)
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required, numeric, email } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Contacts')

export default {
  name: 'ModalContacts',
  mixins: [ModalMixin1],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    customer: {
      type: String,
      default: null
    }
  },
  // data: () => ({}),
  validations () {
    return {
      form: {
        name: {
          required
        },
        position: {
          required
        },
        phone: {
          numeric,
          required
        },
        email: {
          required,
          email
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isModalVisible', 'catalog'])
  },
  async created () {
    this.getCatalog()
  },
  methods: {
    ...mapActions([
      'addRecord',
      'editRecord',
      'deleteRecord',
      'setModalVisible',
      'loadCatalog'
    ])
  }
}
</script>
